export default __webpack_public_path__ + "static/media/true_sume_b_eng.4212d264.png";